export default class CommonAbstractServices {
  static getBusinessHours() {
    logger.error(`Common:: getBusinessHours() not implemented`);
  }

  static getSearchPrediction() {
    logger.error(`Common:: getSearchPrediction() not implemented`);
  }

  static uploadRebateFormPdf() {
    logger.error(`Common:: uploadRebateFormPdf() not implemented`);
  }
}
